import { render } from "./showExchangeReceipt.vue?vue&type=template&id=16338362&scoped=true"
import script from "./showExchangeReceipt.vue?vue&type=script&lang=js"
export * from "./showExchangeReceipt.vue?vue&type=script&lang=js"

import "./showExchangeReceipt.vue?vue&type=style&index=0&id=16338362&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16338362"]])

export default __exports__